<template>
  <div class="small-tabs">
    <div
      class="tab"
      v-for="(tab, index) in itemData"
      @click="changeActiveValue(index)"
      :class="active === index ? 'active' : ''"
      :key="index"
      v-if="itemData"
    >
      <div class="small-tab-btn top" v-if="_.get(tab, 'title')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="5.844"
          height="9.566"
          viewBox="0 0 5.844 9.566"
        >
          <g
            id="Group_1006"
            data-name="Group 1006"
            transform="translate(1.061 8.506) rotate(-90)"
          >
            <path
              id="Path_61"
              data-name="Path 61"
              d="M0,3.722,3.722,0"
              transform="translate(3.723 0)"
              fill="none"
              stroke="#444958"
              stroke-linecap="round"
              stroke-width="1.5"
            />
            <path
              id="Path_60"
              data-name="Path 60"
              d="M3.722,3.722,0,0"
              transform="translate(0 0)"
              fill="none"
              stroke="#444958"
              stroke-linecap="round"
              stroke-width="1.5"
            />
          </g>
        </svg>

        <div class="noto-semibold ttl">{{ _.get(tab, "title") }}</div>
      </div>

      <slide-up-down
        class="content"
        :active="active === index"
        :duration="600"
        v-if="_.get(tab, 'content')"
      >
        <div class="txt" v-html="_.get(tab, 'content')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="925.5"
            height="1"
            viewBox="0 0 925.5 0.5"
          >
            <line
              id="Line_27"
              data-name="Line 27"
              x2="925"
              transform="translate(0.25 0.25)"
              fill="none"
              stroke="#bcbec0"
              stroke-linecap="round"
              stroke-width="0.5"
              stroke-dasharray="10"
            />
          </svg>
        </div>
      </slide-up-down>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemData: Array,
    required: true,
  },
  data() {
    return {
      active: "",
    };
  },

  methods: {
    changeActiveValue: function (index) {
      if (this.active === index) {
        this.active = "";
      } else {
        this.active = index;
      }
    },
  },
};
</script>

<style scoped>
.small-tab-btn.top {
  margin-right: 0;
}
</style>